<template>
	<div class="breadcrumb">
		<div class="routerLink" v-for="(router,index) in routerLinks" :key="index">
			<router-link :to="{ path: router.path, query: router.query }"
				class="breadcrumb-item">{{router.title}}</router-link>
			<span class="breadcrumb-separator">></span>
		</div>
		<span class="breadcrumb-item current">{{currentTitle}}</span>
	</div>
</template>

<script>
	export default {
		name: 'BreadCrumb',
		props: {
			routerLinks: {
				type: Array,
				default: () => []
			},
			currentTitle: {
				type: String,
				default: ''
			}
		}
	}
</script>

<style lang="scss" scoped>
	/* 面包屑导航样式 */
	.breadcrumb {
		margin-top: .32rem;
		display: flex;
		align-items: center;
		font-weight: 400;
		font-size: .14rem;
		color: #000000;
	}

	.routerLink {
		display: flex;
		align-items: center;
	}

	.breadcrumb-item {
		color: #000000;
		text-decoration: none;
		transition: color 0.3s ease;
	}

	.breadcrumb-item:hover {
		color: #000000;
	}

	.breadcrumb-item.current {
		color: #000000;
		font-weight: 500;
	}

	.breadcrumb-separator {
		margin: 0 0.02rem;
		color: #000000;
	}
</style>